import * as React from 'react';
import {CardBodyView} from './Card.styles';
import {useSize, type SizeContextSizeValue} from '../../themes';
import type {HTMLAttributes, SpringTooling} from '../__SharedTypes';

export type CardBodyProps = {
  children: React.ReactNode;
  /**
   * If isScrollable is `true`, overflow-y is set to `auto`, making the CardBody scrollable.
   */
  isScrollable?: boolean;
  /**
   * If isSeamless is `true`, then the CardBody will have no padding.
   */
  isSeamless?: boolean;
  /**
   * Size determines the padding applied to the CardBody.
   */
  size?: SizeContextSizeValue;
} & HTMLAttributes &
  SpringTooling;

export const CardBody = React.forwardRef<HTMLDivElement, CardBodyProps>(
  (
    {
      children,
      isScrollable = false,
      isSeamless = false,
      size: sizeProp,
      ...rest
    }: CardBodyProps,
    ref
  ) => {
    const size = useSize(sizeProp);
    return (
      <CardBodyView
        isScrollable={isScrollable}
        isSeamless={isSeamless}
        ref={ref}
        size={size}
        {...rest}
      >
        {children}
      </CardBodyView>
    );
  }
);

CardBodyView.displayName = 'CardBody';
// @ts-expect-error - TS2322 - Type 'ComponentType<any>' is not assignable to type '() => string'.
CardBody.toString = CardBodyView;
